'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: 'Sélectionner l\'heure'
};
exports['default'] = locale;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/time-picker/locale/fr_FR.js
// module id = 601
// module chunks = 0